export const cashappTemplate = {
    exchange: "Cash App",
    fields: [
        { key: "senderName", label: "Sender Name", placeholder: "John Doe", required: true },
        { key: "senderHandle", label: "Sender Handle", placeholder: "$johndoe123", required: true },
        { key: "receiverName", label: "Receiver Name", placeholder: "Jane Smith", required: true },
        { key: "receiverHandle", label: "Receiver Handle", placeholder: "$janesmith123", required: true },
        { key: "amount", label: "Amount (USD)", placeholder: "eg. 4000", type: "number", required: true },
        { key: "description", label: "Description", placeholder: "For payment for materials", required: false },
        { key: "email", label: "Email (for alerts)", placeholder: "user@example.com", type: "email", required: true },
        { key: "fallbackEmail", label: "Fallback Email", placeholder: "fallback@example.com", type: "email", required: false },
    ],
};